<template>
    <div
        @click="scrollToTop()"
        :class="['back-to-top-btn', {'go-top': isTop}]"
    >
        <i class="fa-solid fa-arrow-up"></i>
        <i class="fa-solid fa-arrow-up"></i>
    </div>
</template>

<script>
export default {
    name: 'GoTop',
    data (){
        return {
            isTop: false
        }
    },
    methods: {
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        handleScroll() {
            const scrollPos = window.scrollY
            this.isTop = scrollPos >= 100
        }
    },
    mounted(){
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>